import ajax from "ajax"
import signals from "./signals"
import _ from "lodash"

async function start_trainer(
  quiz,
  quiz_mode,
  configuration = {},
  tracking_data = {},
  summary_path,
) {
  signals.emit(tracking_name(quiz), _.pickBy({
    quiz_id: quiz.id,
    slug: quiz.slug,
    owned_by: quiz.owned_by,
    performed_by: quiz.performed_by,
    selection: quiz_mode,
    ...(quiz.selection || {}),
    ...configuration,
    ...tracking_data
  }))

  // pickBy == only uses attributes which are truthy
  const params = _.pickBy({
    configuration,
    quiz_slug: quiz.slug,
    quiz_type: quiz_mode,
    locale: window.gon.locale,
    custom_quiz_selection: quiz.selection,
    source_path: window.location.pathname,
    summary_path: summary_path || quiz.summary_path || window.location.pathname
  })
  const {training_session_slug} =
    await ajax.post(window.gon.api_training_sessions_path, params)

  window.location =
    `${window.gon.training_path}?session=${training_session_slug}`
}

function tracking_name(quiz) {
  if (is_custom_quiz(quiz)) {
    return "kenhub.custom_quiz_started"
  }
  return "kenhub.quiz_started"
}

function is_custom_quiz(quiz) {
  return !quiz.slug || quiz.slug === "custom-quiz-1" || quiz.slug.match(/^cq_/)
}

export default start_trainer
